import { put, takeEvery, call, select, delay, spawn } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import { 
    BOOKMARK_CREATE_SUCCESS,
    BOOKMARK_UPDATE_SUCCESS,
    BOOKMARK_REMOVE_SUCCESS,
    SPACE_REFRESH_REQ
} from '../constants/bookmarks'
import {
    COLLECTION_CREATE_SUCCESS,
    COLLECTION_UPDATE_SUCCESS,
    COLLECTION_REMOVE_SUCCESS,
    COLLECTIONS_REFRESH_REQ
} from '../constants/collections'

const channel = typeof BroadcastChannel != 'undefined' ? new BroadcastChannel('askwise_sync') : null

function createSyncChannel() {
    return eventChannel(emitter => {
        if (!channel) return ()=>{}
        channel.onmessage = (e) => emitter(e.data)
        return () => channel.close()
    })
}

function* refreshAllSpaces() {
    const state = yield select()
    const spaces = state.bookmarks?.spaces || {}
    const spaceIds = Object.keys(spaces)

    for (const spaceId of spaceIds) {
        const space = spaces[spaceId]
        if (space.status?.main == 'loaded') {
            yield put({ type: SPACE_REFRESH_REQ, spaceId })
        }
    }
}

function* onExternalChange(action) {
    if (action.type === 'BOOKMARKS_CHANGED') {
        yield call(refreshAllSpaces)
    } else if (action.type === 'COLLECTIONS_CHANGED') {
        yield put({ type: COLLECTIONS_REFRESH_REQ })
    }
}

function* broadcastChange(action) {
    if (!channel || action.ignore) return

    if (action.type.includes('BOOKMARK')) {
        channel.postMessage({ type: 'BOOKMARKS_CHANGED' })
    } else if (action.type.includes('COLLECTION')) {
        channel.postMessage({ type: 'COLLECTIONS_CHANGED' })
    }
}

function* heartbeat() {
    while (true) {
        yield delay(30000) // 30 seconds
        yield call(refreshAllSpaces)
        yield put({ type: COLLECTIONS_REFRESH_REQ })
    }
}

export default function* syncSaga() {
    if (!channel) return

    const syncChannel = yield call(createSyncChannel)
    yield spawn(heartbeat)

    // Listen for local changes to broadcast
    yield takeEvery([
        BOOKMARK_CREATE_SUCCESS,
        BOOKMARK_UPDATE_SUCCESS,
        BOOKMARK_REMOVE_SUCCESS,
        COLLECTION_CREATE_SUCCESS,
        COLLECTION_UPDATE_SUCCESS,
        COLLECTION_REMOVE_SUCCESS
    ], broadcastChange)

    // Listen for external changes from other tabs
    yield takeEvery(syncChannel, onExternalChange)
}
